goog.provide("shadow.js.shim.module$src$svg$wpp$content$movie_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$movie_svg");
shadow.js.shim.module$src$svg$wpp$content$movie_svg = shadow.js.nativeProvides["src/svg/wpp/content/movie.svg"] = shadow$bridge("src/svg/wpp/content/movie.svg");
module$shadow_js_shim_module$src$svg$wpp$content$movie_svg.default = shadow.js.shim.module$src$svg$wpp$content$movie_svg;
